// api.js
import axios from "axios";

export const api = axios.create({
  baseURL: "/api",
  timeout: 60000,
  headers: {
    Accept: "application/json",
  },
});

api.interceptors.request.use((config) => {
  const apiToken = localStorage.getItem("api_token");

  if (apiToken) {
    config.headers.Authorization = `Bearer ${apiToken}`;
  }

  if (config.data instanceof FormData) {
    const parts = config.url?.split("/") || [];
    const action = parts[parts.length - 1];

    if (action && !config.data.has("action")) {
      config.data.append("action", action);
    }

    delete config.headers["Content-Type"];
  } else if (config.data) {
    config.headers["Content-Type"] = "application/json";
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      const message = error.response.data?.message || error.response.data?.error || "Ошибка сервера";

      if (status === 401) {
        localStorage.removeItem("api_token");
      }

      return Promise.reject({
        success: false,
        message,
        status,
      });
    }

    return Promise.reject({
      success: false,
      message: "Нет ответа от сервера",
    });
  },
);
